<template>
  <div id="login">
    <form @submit.prevent="loginUser()">
      <br />
      <br />
      <br />
      <br />
      <br />
      <h2>Login</h2>
      <br />

      <div class="p-input-icon-left">
        <i class="pi pi-user" />
        <InputText
          class="p-mb-3"
          type="text"
          v-model="email"
          placeholder="Email"
        />
      </div>
      <br />
      <div class="p-input-icon-left">
        <i class="pi pi-lock" />
        <InputText
          class="p-mb-3"
          type="password"
          v-model="password"
          placeholder="Password"
        />
      </div>
      <br />
      <Button
        class="loginbutton"
        label="Log in"
        type="submit"
        icon="pi pi-sign-in"
        iconPos="right"
      />
      <Toast position="bottom-center" />
    </form>
    <div class="lower">
      <router-link to="/signup">CREATE ACCOUNT</router-link>
    </div>
  </div>
</template>

<script>
import { fb_auth } from "../firebase";
export default {
  name: "Login",
  data() {
    return {
      email: null,
      password: null,
    };
  },
  methods: {
    loginUser() {
      if (this.email && this.password) {
        fb_auth
          .signInWithEmailAndPassword(this.email, this.password)
          .then((user) => {
            console.log(user);
            this.$store.commit("setCurrentUser", user.user);
            this.$store.dispatch("fetchUserProfile");
            this.$router.push({ path: "/layout" });
          })
          .catch((error) => {
            // Handle Errors here.
            var errorCode = error.code;
            if (errorCode == "auth/wrong-password") {
              errorCode = "Incorrect Password";
            }
            var errorMessage = error.message;
            console.log(errorCode, errorMessage);
            this.$toast.add({
              severity: "error",
              summary: errorCode,
              detail: errorMessage,
              life: 3000,
            });
          });
      } else {
        this.$toast.add({
          severity: "warn",
          summary: "Form Incomplete",
          detail: this.email
            ? "Password cannot be empty."
            : "Email cannot be empty",
          life: 3000,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#login {
  color: #999999;
}

.loginbutton {
  background-color: #FFCC5C;
  border-color: #FFCC5C;
}

.loginbutton:enabled:hover,
.loginbutton:enabled:active {
  color: white;
  border-color: #FFCC5C;
}

.loginbutton:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.2rem white;
}
.lower {
  padding: 50px 0px;
}
</style>